import { useState } from 'react';
import { RadioGroup } from '@stitch-fix/mode-react';
import { SortQueryParam, sortQueryParam } from '../../../utils/hooks/useSearchParams';
import { SortFragment } from '../../../utils/hooks/getSearchResults';
import MenuSheet from '../MenuSheet';
type SortMenuProps = {
  sortOptions: SortFragment[];
  initialSortValue?: string;
  onViewResultsClick: (id: SortQueryParam, selectedValue: string) => void;
  onResetClick: () => void;
};

/**
 * `SortMenu` allows clients to select a single sort option when viewing search results.
 */
const SortMenu = ({
  sortOptions,
  initialSortValue,
  onViewResultsClick,
  onResetClick
}: SortMenuProps) => {
  const defaultSortValue = sortOptions.find(sortOption => sortOption.isDefault)?.value || '';
  const initialSelectedValue = initialSortValue || defaultSortValue;
  const [selectedValue, setSelectedValue] = useState(initialSelectedValue);
  return <MenuSheet label="Sort" onClose={() => setSelectedValue(initialSelectedValue)} onViewResultsClick={() => {
    onViewResultsClick(sortQueryParam, selectedValue);
  }} onResetClick={onResetClick} isResetDisabled={selectedValue === defaultSortValue}>
      <RadioGroup name={sortQueryParam} value={selectedValue} onChange={setSelectedValue} options={sortOptions} direction="vertical" />
    </MenuSheet>;
};
export default SortMenu;